export const setLoadingCount = (state, count) => {
  state.loadingCount = count;
};

// 更新金額中
export const setCartLoading = (state, status) => {
  state.isCartLoading = status;
};
